import { gql, useSuspenseQuery } from '@apollo/client';

type OrganizationData = {
    id: string;
    logoUrl: string | null;
};

/**
 * Hook to fetch the current organization's logo URL.
 * Returns the organization data including id and logoUrl.
 */
export const useCurrentOrganization = (): OrganizationData | null => {
    const { data } = useSuspenseQuery<{
        currentOrganization: OrganizationData | null;
    }>(gql`
        query CurrentOrganization {
            currentOrganization {
                id
                logoUrl
            }
        }
    `);

    return data.currentOrganization;
};
